/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import {deburrFrenchEnglish} from 'mad-utils/lib/react';

/**************************************** PROJECT MODULES *****************************************/
import {getPolyglot} from '../setup/polyglot-factory';
import {translate, RecordModel} from '@canimmunize/core-imports';

/****************************************** TRANSLATIONS ******************************************/
const polyglot = getPolyglot();

/**
 * Translation function to pass up to Javelin
 *
 * @param {string} strId String ID to get value for (get value for current language)
 * @return {string} String corresponding to given string ID in current language
 */
export const translateFn = (strId: string): string => {
    if (typeof strId === 'string' || (strId && (strId as any).sID)) return polyglot.t(strId.sID);

    // Handle case where no string found
    return `__STRING_ID_MISSING__::${strId}`;
};

/**
 * Build a locale-friendly prefixed region: e.g. "de la Nouvelle Écosse"
 *
 * Possible return values:
 *     province_prefixed_ab province_prefixed_bc province_prefixed_mb province_prefixed_nb
 *     province_prefixed_nl province_prefixed_ns province_prefixed_nt province_prefixed_nu
 *     province_prefixed_on province_prefixed_pe province_prefixed_qc province_prefixed_sk
 *     province_prefixed_yt
 *
 * @param {RecordModel} Record model to get region ID off of
 * @return {string} Locale-friendly prefixed region as string (e.g. "de l’Ontario")
 */
export const buildPrefixedRegion = (recordModel: RecordModel): string => {
    const regionID = recordModel.region.toLowerCase();
    return translate(`province_prefixed_${regionID}`);
};

/**
 * Compare deburred strings as lowercase
 * Return true if strings are equal when deburred
 */
export const deburrCompare = (str1: string, str2: string): boolean =>
    deburrFrenchEnglish(str1.toLowerCase()) === deburrFrenchEnglish(str2.toLowerCase());
